// used for interactive card scale down animation
export const CARD_SCALE_DOWN_VALUE = 0.95;
export const CARD_SCALE_UP_VALUE = 1.05;
export const CARD_LINK_OVERLAY_ID = 'card-link-overlay';
